import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '~/state/reducers';

export interface NotificationState {
  show: boolean;
  type: string;
  title: string;
  body: string;
  size: string;
  backdrop: boolean;
  redirectOnOk: string;
}

const initialState: NotificationState = {
  show: false,
  type: 'error',
  title: 'Notification!',
  body: 'Notification Body',
  size: 'sm',
  backdrop: true,
  redirectOnOk: '/',
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotificationState: (state, action: PayloadAction<Partial<NotificationState>>) => {
      return { ...state, ...action.payload };
    },
    resetNotificationState: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setNotificationState, resetNotificationState } = notificationSlice.actions;

export const getNotificationState = (state: RootState) => state.notification;

export default notificationSlice.reducer;
